// needs popUpMessageChange action to work
// responseDataChange action optional
export function showMessage(props, message, config=null) {
    const defaultMessageTime = 2000;
    const popUpMessageConfig = {
        show: true,
        message: message,
        closeButton: false,
        loading: false,
        ...config
    };
    if (props.popUpMessageChange) {
        props.popUpMessageChange(popUpMessageConfig);
    }
    if (!popUpMessageConfig.removeDateChangeConfirmationCloseButton && (!popUpMessageConfig.closeButton && !popUpMessageConfig.loading)) {
        const messageTime = popUpMessageConfig.messageTime ? popUpMessageConfig.messageTime : defaultMessageTime;
        setTimeout(() => {
            closeMessage(props);
        }, messageTime);
    }
}

function closeMessage(props) {
    if (props.popUpMessageChange) {
        props.popUpMessageChange({ show: false });
    }
    if (props.responseDataChange) {
        props.responseDataChange({});
    }
}